import qs from 'qs'
import { apiUrl } from './../auth-provider';
import { useAuth } from './../context/auth-context';
import { useCallback } from 'react';
import * as Auth from '../auth-provider'

export const http = (endpoint, { data, token, headers, ...customConfig }) => {
  let configHeader = {}
  if (token) {
    configHeader = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  } else {
    configHeader = {
      'Content-Type': 'application/json',
    }
  }
  const config = {
    method: 'GET',
    headers: configHeader,
    ...customConfig
  }
  if (config.method.toUpperCase() === 'GET') {
    endpoint = data ? `${endpoint}?${qs.stringify(data)}` : endpoint
  } else {
    config.body = JSON.stringify(data)
  }

  return window.fetch(`${apiUrl}/${endpoint}`, config).then(async response => {
    if (response.status === 404) {
      return Promise.reject({ msg: '你访问的资源不存在' })
    }
    const res = await response.json()
    if (response.ok) {
      if (res.code === 200) {
        return res
      } else if (res.code === 401) {
        await Auth.logout()
        window.location.reload()
        return Promise.reject(res)
      } else {
        return Promise.reject(res)
      }
    } else {
      return Promise.reject(res)
    }
  })
}

//获取context中的user的token
export const useHttp = () => {
  const { user } = useAuth()
  return useCallback((endpoint, config) => http(endpoint, { ...config, token: user?.access_token }), [user?.access_token])
}